import { render, staticRenderFns } from "./EmailConfig.vue?vue&type=template&id=037f8c99&scoped=true"
import script from "./EmailConfig.vue?vue&type=script&lang=js"
export * from "./EmailConfig.vue?vue&type=script&lang=js"
import style0 from "./EmailConfig.vue?vue&type=style&index=0&id=037f8c99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037f8c99",
  null
  
)

export default component.exports